import { clearUserProfile } from './userProfileStorage';

const KEYS = {
  GUEST_IDENTITY_ID: 'guestIdentityId',
  TOKEN: 'token',
  ID_TOKEN: 'idToken',
  REFRESH_TOKEN: 'refreshToken',
  AUTH_PHONE: 'authPhone',
  AUTH_EMAIL: 'authEmail',
  AUTH_METHOD: 'authMethod',
  AUTH_COUNTRY_CODE: 'authCountryCode',
  AUTH_COUNTRY_ISO: 'authCountryIso',
  AUTH_VERIFIED: 'authVerified',
  OTP_CHALLENGE_SESSION: 'otpChallengeSession',
  OTP_CHALLENGE_NAME: 'otpChallengeName',
};

export function getGuestIdentityId() {
  return localStorage.getItem(KEYS.GUEST_IDENTITY_ID);
}

export function setGuestIdentityId(identityId) {
  localStorage.setItem(KEYS.GUEST_IDENTITY_ID, identityId);
}

export function getAuthToken() {
  return localStorage.getItem(KEYS.TOKEN) || localStorage.getItem(KEYS.ID_TOKEN);
}

export function setAuthToken(token) {
  if (token) {
    localStorage.setItem(KEYS.TOKEN, token);
    localStorage.setItem(KEYS.AUTH_VERIFIED, 'true');
  }
}

export function setAuthSession({ token, idToken, refreshToken, phone, email, method, countryCode, countryIso, verified }) {
  if (token) localStorage.setItem(KEYS.TOKEN, token);
  if (idToken) localStorage.setItem(KEYS.ID_TOKEN, idToken);
  if (refreshToken) localStorage.setItem(KEYS.REFRESH_TOKEN, refreshToken);
  if (phone) localStorage.setItem(KEYS.AUTH_PHONE, phone);
  if (email) localStorage.setItem(KEYS.AUTH_EMAIL, email);
  if (method) localStorage.setItem(KEYS.AUTH_METHOD, method);
  if (countryCode) localStorage.setItem(KEYS.AUTH_COUNTRY_CODE, countryCode);
  if (countryIso) localStorage.setItem(KEYS.AUTH_COUNTRY_ISO, countryIso);
  if (verified) localStorage.setItem(KEYS.AUTH_VERIFIED, 'true');
}

export function setOtpChallengeSession({ session, challengeName }) {
  if (session) localStorage.setItem(KEYS.OTP_CHALLENGE_SESSION, session);
  if (challengeName) localStorage.setItem(KEYS.OTP_CHALLENGE_NAME, challengeName);
}

export function getOtpChallengeSession() {
  return {
    session: localStorage.getItem(KEYS.OTP_CHALLENGE_SESSION) || '',
    challengeName: localStorage.getItem(KEYS.OTP_CHALLENGE_NAME) || 'CUSTOM_CHALLENGE',
  };
}

export function clearOtpChallengeSession() {
  localStorage.removeItem(KEYS.OTP_CHALLENGE_SESSION);
  localStorage.removeItem(KEYS.OTP_CHALLENGE_NAME);
}

export function getAuthPhoneDetails() {
  const phone = localStorage.getItem(KEYS.AUTH_PHONE) || '';
  const email = localStorage.getItem(KEYS.AUTH_EMAIL) || '';
  const method = localStorage.getItem(KEYS.AUTH_METHOD) || (email ? 'email' : 'phone');

  return {
    phone,
    email,
    method,
    identifier: method === 'email' ? email : phone,
    countryCode: localStorage.getItem(KEYS.AUTH_COUNTRY_CODE) || '91',
    countryIso: localStorage.getItem(KEYS.AUTH_COUNTRY_ISO) || 'IN',
  };
}

export function clearAuthSession() {
  Object.values(KEYS).forEach((key) => localStorage.removeItem(key));
  clearUserProfile();
}

export function isAuthenticated() {
  return Boolean(getAuthToken());
}
